import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  knowledgebaseList: [],
  knowledgebaseItem: {},
  knowledgebaseOverridesList: [],
  knowledgebaseOverridesItem: {},
  knowledgebaseOverridesLoading: false,
  loading: false,
};

const knowledgebaseSlice = createSlice({
  name: 'knowledgebaseSlice',
  initialState,
  reducers: {
    knowledgebaseLoadingSlice: (state, { payload }) => {
      state.loading = payload;
    },
    knowledgebaseListSlice: (state, { payload }) => {
      state.knowledgebaseList = payload;
    },
    knowledgebaseItemSlice: (state, { payload }) => {
      state.knowledgebaseItem = payload;
    },
    knowledgebaseOverridesListSlice: (state, { payload }) => {
      state.knowledgebaseOverridesList = payload;
    },
    knowledgebaseOverridesItemSlice: (state, { payload }) => {
      state.knowledgebaseOverridesItem = payload;
    },
    knowledgebaseOverridesLoadingSlice: (state, { payload }) => {
      state.knowledgebaseOverridesLoading = payload;
    },
  },
});

const { actions, reducer } = knowledgebaseSlice;

export const {
  knowledgebaseLoadingSlice,
  knowledgebaseListSlice,
  knowledgebaseItemSlice,
  knowledgebaseOverridesListSlice,
  knowledgebaseOverridesItemSlice,
  knowledgebaseOverridesLoadingSlice,
} = actions;

export default reducer;
